<template>
  <div class="apartment_container" >
    <div class="apartment-index">{{ index + 1 }}</div>
    <div class="fields_container">
        <li>
            <label>מספר חדרים</label>
            <input type="number" min="0" step="0.5" v-model="item.num_units">
        </li>
        <li>
            <label>חנייה</label>
            <input type="number" min="0" v-model="item.num_parking">
        </li>
        <li>
            <label>מחסן</label>
            <input type="number" min="0" v-model="item.num_storage">
        </li>
        <li class="select_container">
            <label>כיווני אוויר</label>
            <!-- <multiselect
                v-model="item.air_directions"
                :options="$store.airdirections"
                :closeOnSelect="false"
                :multiple="true"
                :searchable="false"
                placeholder="בחרו"
                selectLabel="לחצו לבחירה"
                deselectLabel="לחצו להסרה"
                label="name"
                track-by="id"
            /> -->
            
            <wzMultiSelect v-model="item.air_directions" :settings="{ width: '100%', val: 'name', key: 'id', theme: 'light', max_width: '167px', }" :options="$store.airdirections" />
        </li>
        <li class="select_container">
            <label>סוג בעלות</label>
            <WzSelect v-model="item.type_ownership" :settings="{ theme: 'light', width: '100%',height: '100%' }" :options="$store.ownerships.map(row => { return { key: row.id, val: `${row.name}` } })" />
        </li>
        <li class="select_container">
            <label>סוג נכס</label> 
            <WzSelect v-model="item.apartment_type" :settings="{ theme: 'light', width: '100%',height: '100%' }" :options="$store.apartment_types.map(row => { return { key: row.id, val: `${row.name}` } })" />
        </li>
        
        <!-- <li>
            <p class="text">דירת גן</p>
            <div class="theme-switch-wrapper mid">
                <span>כן</span>
                <label class="theme-switch" :for="id">
                    <input v-model="item.is_garden" type="checkbox"  :id="id" />
                    <div class="slider round"></div>
                </label>
                <span>לא</span>
            </div>
        </li>
        <li>
            <p class="text">דירת גג</p>
            <div class="theme-switch-wrapper mid">
                <span>כן</span>
                <label class="theme-switch" :for="id+'a'">
                    <input v-model="item.is_roof" type="checkbox" :id="id+'a'" />
                    <div class="slider round"></div>
                </label>
                <span>לא</span>
            </div>
        </li> -->
        <li class="select_container">
            <label>הערות מיוחדות על היחידה</label>
       
            <!-- <multiselect
                v-model="item.more_fields"
                :options="$store.spe_notes"
                :closeOnSelect="false"
                :multiple="true"
                :searchable="false"
                placeholder="בחרו סוגים"
                selectLabel="לחצו לבחירה"
                deselectLabel="לחצו להסרה"
                label="name"
                track-by="id"
            /> -->
            <wzMultiSelect v-model="item.more_fields" :settings="{ width: '100%', val: 'name', key: 'id', theme: 'light', max_width: '167px', }" :options="$store.spe_notes" />
      
        </li>
    </div>
    <div class="fields_container">
        <li >
            <label>סוג האכלוס</label>
            <WzSelect v-model="item.population_type" :settings="{ theme: 'light', width: '100%',height: '100%' }" :options="$store.population_type.map(row => { return { key: row.id, val: `${row.name}` } })" />
        </li>
        <li>
            <label>אוכלוסיה מיוחדת</label>
            <dropdwon-count  :fields="countFields" @change="countFieldsChange" />
        </li>
        
        <li>
            <label>שטח יחידה לפי הטאבו</label>
            <input step="0.5" type="number" placeholder="שטח" v-model="item.field_unit_tabo">
        </li>
        
        <li>
            <label>שטח יחידה לפי ארנונה</label>
            <input step="0.5" type="number" placeholder="שטח" v-model="item.field_unit_arnona">
        </li>
    </div>
    <div class="fields_container">
        <li class="spetiol_note">
            <input type="text" placeholder="הערה מיוחדת" v-model="item.special_note">
        </li>
    </div>
    
</div>
</template>

<script>
import DropdwonCount from '../DropdwonCount.vue';
// import Multiselect from 'vue-multiselect'
import WzMultiSelect from '../wzMultiSelect.vue';
import WzSelect from '../wzselect.vue';

export default {
    props:{
        index:{
            type: Number,
            required: true
        },
        apartmentComp:{
            type: Object,
            required: true
        }
    },
     components: {
      WzMultiSelect,
    //   Multiselect,
      WzSelect,
          DropdwonCount
    },
     beforeMount(){
        this.item = this.apartmentComp;

        this.countFields.map(field => field.value = (this.item[field.key] ?? 0))

    },
    data() {
        return {
            more_fields: [],
            id: this.random_id(),
            item: this.apartmentComp,
            options: [
                { name: 'Vue.js', id: 'JavaScript' },
                { name: 'Adonis', id: 'JavaScript' },
                { name: 'Rails', id: 'Ruby' }
            ],
            countFields: [
                { key: '70_year_old_plus', label: 'קשיש (גילאי 70+)', value: 0 },
                { key: '75_year_old_plus', label: 'קשיש מעל גיל 75', value: 0 },
                { key: 'patient_likely_die', label: 'חולה נוטה למות', value: 0 },
                { key: 'disability_peoples', label: 'מעוטי יכולת', value: 0 }
            ]
         
        }
    },
    methods: {
       countFieldsChange(fields) {
            fields.forEach(field => this.item[field.key] = field.value)
        },
         random_id() {
            // This function generates a string of 10 random characters
            // You can adjust the length by changing the number 10
            return Math.random().toString(36).substring(2, 12);
        },
    },
    watch: {
        item: {
            handler: function (val) {
                this.$emit('update', val)
            },
            deep: true
        }
    },

}
</script>

<style lang="scss">
.apartment_container {
    position: relative;
    
    .apartment-index { position: absolute; top: 0; right: -0; font-weight: bold; color: #333; font-size: 1.1rem; background-color: #f5f5f5; border-radius: 50%; width: 25px; height: 25px; display: flex; align-items: center; justify-content: center; box-shadow: 0 1px 3px rgba(0,0,0,0.2); }
    
    .fields_container {
        label { white-space: nowrap;}
    }
}

@media (max-width: 768px) {
    .apartment_container {
        padding:30px 5px !important;
        gap:10px;
        .apartment-index { 
            right: 2px;
         }
         .fields_container {
            flex-direction: column;
            gap: 16px !important;
            

            li { display: flex; flex-direction: column;
                label { white-space: normal;
                }
            }
            input{
                font-size: 14px;
            }
        }
    }
}
</style>
